import FileResizer from 'react-image-file-resizer'

export function getBase64(img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}

export function getBase64V2(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })
}

const maxWidth = 2048
const minWidth = 2048

export const resizeFile = (file, type = 'file') => new Promise((resolve) => {
  FileResizer.imageFileResizer(
    file,
    maxWidth,
    minWidth,
    'JPEG',
    90,
    0,
    (uri) => {
      resolve(uri)
    },
    type
  )
})
